var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-box-button"},[_c('button',{class:{ 'active': _vm.active === true },attrs:{"role":"button"},on:{"click":function($event){return _vm.onClick(_vm.name)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }